export default __webpack_public_path__ + "static/media/bsCoreShapesBackground.06e6dec6.svg";